import zod from 'zod';
import { AddressFormSchema } from '../AddressService/schemas';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const LicenseEditionFormSchema = zod.object({
  email: zod
    .string({ required_error: MANDATORY_FIELD })
    .email('Email inválido'),
  name: zod.string().min(1, MANDATORY_FIELD),
  password: zod
    .string({ required_error: MANDATORY_FIELD })
    .min(8, 'Senha com mín. de 8 caracteres'),
  cpf: zod.string().optional(),
  cnpj: zod.string().optional(),
  address: AddressFormSchema.optional(),
  plans: zod.array(
    zod.enum([
      'EDUCATION_BASIC',
      'EDUCATION_STANDARD',
      'EDUCATION_PREMIUM',
      'EDUCATION_DELUX',
      'SECURITY_BASIC',
      'SECURITY_STANDARD',
      'SECURITY_PREMIUM',
      'SECURITY_DELUX',
      'TRAFFIC_BASIC',
      'TRAFFIC_STANDARD',
      'TRAFFIC_PREMIUM',
      'TRAFFIC_DELUX',
      'RETAIL_BASIC',
      'RETAIL_STANDARD',
      'RETAIL_PREMIUM',
      'RETAIL_DELUX',
      'ALERTAI',
      'SPORTS_BASIC',
      'SPORT_STANDARD',
      'SPORTS_PREMIUM',
      'SPORTS_DELUX',
    ]),
  ),
  isTrial: zod.boolean(),
});
